import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import {
  getCampaignTikTokDetails,
  getCampaignTikTokVideos,
} from 'Redux/actions/influencerActions'
import { getCampainVideos } from 'Redux/selectors/influencer'
import { CampainVideo, CampainVideos } from 'Redux/reducers/influencerReducer'
import { VideoStatus } from 'Constants/enums'
import Block from './components/Block'
import DetailsHeader from './components/DetailsHeader'
import DetailsCard from './components/DetailsCard'
import VideoCard from './components/VideoCard'

import {
  BlockOfCards,
  DetailsContainer,
  Number,
  StyledList,
  StyledTabs,
  StyledTabsItem,
  TabName,
  Videos,
} from './styles'
import { CampainDetails } from './DetailsProps'

// @ts-ignore
const Details = ({ match }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  // @ts-ignore
  const [campaignDetails, setCampaignDetails] = useState<CampainDetails>(null)
  const campaignVideos: CampainVideos = useSelector(getCampainVideos)
  const campaignID = +match.params.campaignID

  useEffect(() => {
    if (!campaignID) {
      return
    }
    dispatch(
      getCampaignTikTokVideos(campaignID, (error, payload) => {
        if (error) {
          //  TODO add error
          // eslint-disable-next-line no-console
          console.log('errorMessage')
        }
      })
    )

    dispatch(
      // TODO use redux not useState
      getCampaignTikTokDetails(campaignID, (error, payload) => {
        if (error) {
          //  TODO add error
          // eslint-disable-next-line no-console
          console.log('errorMessage')
        }

        setCampaignDetails(payload)
      })
    )
  }, [campaignID])

  const blocks = useMemo(
    () => [
      {
        title: t('campaignResultsPage.videoPublished'),
        value: campaignDetails?.totalVideos || 0,
      },
      {
        title: t('campaignResultsPage.totalViews'),
        value: campaignDetails?.totalViews || 0,
      },
      {
        title: t('campaignResultsPage.totalShares'),
        value: campaignDetails?.totalShares || 0,
      },
      {
        title: t('campaignResultsPage.newVideosOnTrack'),
        value: campaignDetails?.totalVideos || 0,
      },
    ],
    [campaignDetails]
  )

  const groupEvents = useMemo(
    () =>
      campaignVideos.reduce(
        (
          groupEvents: { [group: string]: CampainVideos },
          item: CampainVideo
        ) => {
          if (item.status === VideoStatus.ACCEPTED) {
            groupEvents?.awaiting?.push(item)
            return groupEvents
          }
          if (
            item.status === VideoStatus.AWAITING_REVIEW ||
            item.status === VideoStatus.AWAITING_MODERATOR_REVIEW
          ) {
            groupEvents?.published?.push(item)
            return groupEvents
          }
          if (
            item.status === VideoStatus.APPROVED_AUTOMATICALLY ||
            item.status === VideoStatus.APPROVED_BY_ARTIST ||
            item.status === VideoStatus.APPROVED_BY_ADMIN
          ) {
            groupEvents?.reviewed?.push(item)
            return groupEvents
          }
          if (
            item.status === VideoStatus.CANCELED ||
            item.status === VideoStatus.CANCELED_BY_ARTIST ||
            item.status === VideoStatus.DECLINED
          ) {
            groupEvents?.rejected?.push(item)
            return groupEvents
          }

          return groupEvents
        },
        {
          awaiting: [],
          published: [],
          reviewed: [],
          rejected: [],
        }
      ),
    [campaignVideos]
  )

  const tabs = useMemo(
    () => [
      {
        group: 'all',
        title: t('campaignResultsPage.all'),
        count: campaignVideos?.length || 0,
      },
      {
        group: 'awaiting',
        title: t('campaignResultsPage.awaiting'),
        count: groupEvents?.awaiting?.length || 0,
      },
      {
        group: 'published',
        title: t('campaignResultsPage.published'),
        count: groupEvents?.published?.length || 0,
      },
      {
        group: 'reviewed',
        title: t('campaignResultsPage.reviewed2'),
        count: groupEvents?.reviewed?.length || 0,
      },
      {
        group: 'rejected',
        title: t('campaignResultsPage.rejected'),
        count: groupEvents?.rejected?.length || 0,
      },
    ],
    [groupEvents, campaignVideos]
  )

  return (
    <DetailsContainer>
      <DetailsHeader />
      <DetailsCard campaignDetails={campaignDetails} />
      <BlockOfCards>
        {blocks.map(item => (
          <Block key={item.title} title={item.title} value={item.value} />
        ))}
      </BlockOfCards>
      <Videos>
        <StyledTabs defaultActiveKey="all">
          {tabs?.map(tab => (
            <StyledTabsItem
              tab={
                <>
                  <TabName>{tab.title}</TabName>
                  <Number awaiting={tab.group === 'awaiting'}>
                    {tab.count}
                  </Number>
                </>
              }
              key={tab.group}
            >
              <StyledList>
                {tab?.group === 'all'
                  ? campaignVideos?.map(item => (
                      <VideoCard key={item.id} card={item} />
                    ))
                  : groupEvents[tab.group]?.map(item => (
                      <VideoCard key={item.id} card={item} />
                    ))}
              </StyledList>
            </StyledTabsItem>
          ))}
        </StyledTabs>
      </Videos>
    </DetailsContainer>
  )
}

export default Details
